export default __webpack_public_path__ + "static/icon-30-6-64ee9bc7c442d8be9be1dd3e8436eb9f.png";